import { MatDatetimePickerInputEvent } from '@angular-material-components/datetime-picker';
import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatInput } from '@angular/material/input';

@Component({
  selector: 'app-custom-date-time-picker',
  templateUrl: './custom-date-time-picker.component.html',
  styleUrls: ['./custom-date-time-picker.component.scss'],
})
export class CustomDateTimePickerComponent implements OnChanges {
  @ViewChild('inputpicker', { read: MatInput })
  inputpicker!: MatInput;

  @Input() txtLabel: string = 'Data inicio*';
  @Input() txtPlaceholder: string = 'Data e Hora';
  @Input() inputDateStarted: Date = new Date();
  @Input() clearField: boolean = false;
  @Input() hideTime: boolean = false;

  @Output() dtTmSelected = new EventEmitter<
    MatDatetimePickerInputEvent<Date>
  >();

  formDate: FormControl = new FormControl();

  constructor() {}

  ngOnInit(): void {
    this.formDate = new FormControl(this.inputDateStarted);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.inputpicker) this.inputpicker.value = '';
  }

  emitDate(event: MatDatetimePickerInputEvent<Date>) {
    this.dtTmSelected.emit(event);
  }
}
